export function logInfo(message: string): void {
  if (typeof console !== 'undefined' && console.info) {
    console.info(`[rovo-extension/i18n] ${message}`);
  }
}

export function logError(errorInfo: { error: any; impact: string }): void {
  if (typeof console !== 'undefined' && console.error) {
    console.error(`[rovo-extension/i18n] ${errorInfo.impact}`, errorInfo.error);
  }
}
